import { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { Table } from "../../../../components/Table";
import { Api } from "../../../../services/api";
import { AddMember } from "../../../../components/AddMember";
import { AddMembersType } from "../../../../components/AddMember/addMember";
import { getColumns } from "./columnData";
// import { getColumns } from "../columnData";
import {
  selectMemberMap,
  useAppDispatch,
  useAppSelector,
} from "../../../../store/hooks";
import { setMembers } from "../../../../store/slices/MemberListSlice";
import { Member, RoleMembers } from "../../../../services/api/types/Roles";
import { useAccount, useMsal } from "@azure/msal-react";
import { loginUser } from "../../../../app/App";
import { handleAxiosError } from "../../../../services/utils/handleAxiosError";
import { ColumnContainer } from "../../Admin.styles";

const testData = new Array<Member>();

export const AddTeamMember = () => {
  const dispatch = useAppDispatch();
  const token = useAppSelector(state => state.auth.token);
  const user = useAppSelector(state => state.auth.user);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [tableData, setTableData] = useState<Array<Member>>(testData);

  const { instance, accounts } = useMsal();
  const account = useAccount(accounts[0] || {});

  const history = useHistory();
  const { roleId } = useParams<{ roleId: string }>();

  //pull member and teamTypes from redux
  const members = selectMemberMap();

  const fetchRole = async () => {
    try {
      const response = await Api.roles.getRole(roleId);
      setTableData(response.data.members);
    } catch (error) {
      console.error("Role fetch:", error);
      handleAxiosError(error);
    }
  };

  useEffect(() => {
    fetchRole();
    setIsLoading(false);
  }, [roleId]);

  const navigateToEdit = () => {
    const currentLocation = history.location;
    currentLocation.pathname =
      currentLocation.pathname.split("/").slice(0, -1).join("/") + "/edit";
    history.push(currentLocation);
  };

  const submitValues = (values: AddMembersType) => {
    if (!values.members) return;
    let updatingUser = false;
    const data: RoleMembers = {
      members: [
        ...tableData.map(member => member.id),
        ...values.members.map(name => {
          const memberId = members.get(name as string)?.id || "";
          if (memberId === user.id) updatingUser = true;
          return memberId;
        }),
      ],
    };

    try {
      Api.roles.updateRoleMembers(roleId, data).then(res => {
        console.info(res);
        if (updatingUser) loginUser(dispatch, instance, account);
        Api.members
          .getMembers()
          .then(res => {
            dispatch(setMembers(res.data));
          })
          .catch(() => {
            dispatch(setMembers([]));
          });
        navigateToEdit();
      });
    } catch (error) {
      console.error("Update Team Member:", error);
    }
  };

  const handleCancel = () => {
    navigateToEdit();
  };

  return (
    <ColumnContainer>
      {!isLoading ? (
        <>
          <AddMember
            header={"Add Members"}
            handleCancel={handleCancel}
            submitValues={submitValues}
          />
          <div style={{ width: "100%" }}>
            <Table
              editable
              tableType="Members"
              isLoading={isLoading}
              defaultRows={20}
              columns={getColumns(token)}
              rowsPerPage={[10, 20, 35, 50]}
              data={tableData}
            />
          </div>
        </>
      ) : null}
    </ColumnContainer>
  );
};
